import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import WarningSvg from 'images/warning.svg';
import styles from './EmptyState.module.scss';
function EmptyState({ icon, header, subheader, noHeader = false, noSubheader = false, size = 'l', children, }) {
    const { t } = useTranslation(['common']);
    const classes = classNames(styles.wrap, styles[size]);
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: styles.icon }, icon || React.createElement(WarningSvg, null)),
        !noHeader && React.createElement("h4", { className: styles.header }, header || t('no_results_header')),
        !noSubheader && (React.createElement("h5", { className: styles.subheader }, subheader || t('no_results_subheader'))),
        children && children));
}
export default EmptyState;
